import { UserEducation, UserTraining } from '@borg/types';

const BASE_URL = '/v2/me/education';

type EditEducation =
  | (UserEducation & { isTraining: boolean })
  | (UserTraining & { isTraining: boolean });

type CreateEducation = Omit<EditEducation & { isTraining?: boolean }, 'id'>;

class EducationsRepository extends Repository<EditEducation> {
  getMany(isTraining: boolean) {
    return this._getMany({ url: `${BASE_URL}?isTraining=${isTraining}` });
  }

  get(id: string) {
    return this._get({ url: `${BASE_URL}/${id}` });
  }

  save(data: EditEducation) {
    return this._save({ url: `${BASE_URL}/${data.id}`, data });
  }

  create(data: CreateEducation) {
    return this._create({ url: BASE_URL, data });
  }

  delete(id: string) {
    return this._delete({ url: `${BASE_URL}/${id}` });
  }
}

export const educationsRepository = new EducationsRepository();
